import ui from "../i18n/ui";

// Each generated page sets <html lang> to its locale, so the widget picks the
// matching dictionary without a router or persisted state.
const lang = (typeof document !== "undefined" && document.documentElement.lang) || "en";

export default ui[lang] || ui.en;
